// import React, { useState, useEffect, useRef } from 'react';
// import {
//   DateRangePicker,
//   createStaticRanges,
// } from 'react-date-range';

// import {
//   startOfWeek,
//   endOfWeek,
//   startOfMonth,
//   endOfMonth,
//   subWeeks,
//   subMonths,
//   subDays,
//   startOfYear,
//   endOfYear,
//   subYears,
//   isBefore,
//   isAfter,
//   isValid,
// } from 'date-fns';

// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';

// const DatePicker = ({ onChange, defaultRange, minDate, maxDate }) => {
//   const [open, setOpen] = useState(false);
//   const ref = useRef();
//   // ADD this state for temporary selection


//   const maxDateStr = localStorage.getItem('max_date');
//   const parsedMaxDate = maxDateStr ? new Date(maxDateStr) : null;

//   const isValidDate = (date) => isValid(date) && typeof date.getTime === 'function';

//   const minDateValid = isValidDate(minDate);
//   const maxDateValid = isValidDate(parsedMaxDate);

//   const shouldDisableAll = !minDateValid && !maxDateValid;

//   const maxDateFinal = shouldDisableAll ? null : parsedMaxDate ?? new Date();

//   const getValidRange = () => {
//     const end = maxDateFinal || new Date();
//     let start = subDays(end, 6); // 6 days before the end = total 7 days

//     // Clamp to minDate if provided
//     if (minDate && isBefore(start, minDate)) {
//       start = minDate;
//     }

//     // Safety check: if somehow start is after end
//     if (isAfter(start, end)) {
//       start = end;
//     }

//     return [
//       {
//         startDate: start,
//         endDate: end,
//         key: 'selection',
//       },
//     ];
//   };

//   const [state, setState] = useState(getValidRange());
// const [tempRange, setTempRange] = useState(getValidRange());


//   const todayContext = maxDateFinal ?? new Date();

//   const isRangeWithinBounds = (range) => {
//     return (
//       (!minDate || range.startDate >= minDate) &&
//       (!maxDateFinal || range.endDate <= maxDateFinal)
//     );
//   };

//   const myStaticRanges = [
//     {
//       label: 'Today',
//       range: () => ({
//         startDate: todayContext,
//         endDate: todayContext,
//       }),
//     },
//     {
//       label: 'Yesterday',
//       range: () => {
//         const y = subDays(todayContext, 1);
//         return { startDate: y, endDate: y };
//       },
//     },
//     {
//       label: 'This Week',
//       range: () => ({
//         startDate: startOfWeek(todayContext, { weekStartsOn: 0 }),
//         endDate: endOfWeek(todayContext, { weekStartsOn: 0 }),
//       }),
//     },
//     {
//       label: 'Last Week',
//       range: () => {
//         const lastWeek = subWeeks(todayContext, 1);
//         return {
//           startDate: startOfWeek(lastWeek, { weekStartsOn: 0 }),
//           endDate: endOfWeek(lastWeek, { weekStartsOn: 0 }),
//         };
//       },
//     },
//     {
//       label: 'This Month',
//       range: () => ({
//         startDate: startOfMonth(todayContext),
//         endDate: endOfMonth(todayContext),
//       }),
//     },
//     {
//       label: 'Last Month',
//       range: () => {
//         const lastMonth = subMonths(todayContext, 1);
//         return {
//           startDate: startOfMonth(lastMonth),
//           endDate: endOfMonth(lastMonth),
//         };
//       },
//     },
//   ];

//   const customStaticRanges = [
//     {
//       label: 'This Year',
//       range: () => ({
//         startDate: startOfYear(todayContext),
//         endDate: endOfYear(todayContext),
//       }),
//     },
//     {
//       label: 'Last Year',
//       range: () => {
//         const lastYear = subYears(todayContext, 1);
//         return {
//           startDate: startOfYear(lastYear),
//           endDate: endOfYear(lastYear),
//         };
//       },
//     },
//   ];

//   const filteredStaticRanges = shouldDisableAll
//     ? []
//     : [...myStaticRanges, ...customStaticRanges].filter((item) => {
//         const range = item.range();
//         return isRangeWithinBounds(range);
//       });

//   const staticRanges = createStaticRanges(filteredStaticRanges);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (ref.current && !ref.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const normalizeRange = (range) => {
//     return range.map((r) => ({
//       ...r,
//       startDate: new Date(r.startDate),
//       endDate: new Date(r.endDate),
//     }));
//   };

// useEffect(() => {
//   if (
//     defaultRange &&
//     Array.isArray(defaultRange) &&
//     defaultRange[0]?.startDate &&
//     defaultRange[0]?.endDate
//   ) {
//     const normalized = normalizeRange(defaultRange);
//     setState(normalized);
//     setTempRange(normalized); // ← sync temp as well
//   } else {
//     const initial = getValidRange();
//     setState(initial);
//     setTempRange(initial); // ← sync temp as well
//   }
// }, [defaultRange, minDate, maxDate]);
// const handleRangeChange = (item) => {
//   if (shouldDisableAll) return;
//   setTempRange([item.selection]); // ← Don't update state or call onChange yet
// };

// const handleApply = () => {
//   setState(tempRange);
//   onChange && onChange(tempRange);
//   setOpen(false);
// };
//   return (
//     <div
//       className="inline-block text-left w-full max-w-md custom-date-picker"
//       ref={ref}
//       style={{ position: 'relative', fontSize: 'smaller' }}
//     >
//       <button
//         onClick={() => setOpen(!open)}
//         className="w-full px-4 py-2 border rounded date-picker-btn text-black text-left"
//         disabled={shouldDisableAll}
//       >
//         <i className="bi bi-calendar"></i>&nbsp;
//         {state[0].startDate
//           ? state[0].startDate.toDateString()
//           : 'No date available'}{' '}
//         &nbsp;-&nbsp;
//         <i className="bi bi-calendar"></i>&nbsp;
//         {state[0].endDate ? state[0].endDate.toDateString() : 'No date available'}
//       </button>

//      {open && (
//   <div className="absolute z-50 mt-2 shadow-lg overflow-x-auto datepicker-outer-div" style={{ zIndex: 99999999 }}>
//     <DateRangePicker
//       onChange={handleRangeChange}
//       showSelectionPreview={true}
//       moveRangeOnFirstSelection={false}
//       months={window.innerWidth < 768 ? 1 : 1}
//       ranges={tempRange} // ← use temp range here
//       showDateDisplay={true}
//       direction={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
//       staticRanges={staticRanges}
//       inputRanges={[]}
//       minDate={shouldDisableAll ? null : minDate || new Date()}
//       maxDate={shouldDisableAll ? null : maxDateFinal || new Date()}
//       disabled={shouldDisableAll}
//     />
//     {/* Apply Button */}
//     <div className="p-2 text-right apply-btn-datepicker">
//       <button
//         className="btn auth-btn-datepicker mb-2"
//         onClick={handleApply}
//       >
//         Apply
//       </button>
//     </div>
//   </div>
// )}

//     </div>
//   );
// };

// export default DatePicker;



import React, { useState, useEffect, useRef } from 'react';
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subWeeks,
  subMonths,
  subDays,
  startOfYear,
  endOfYear,
  subYears,
  isBefore,
  isAfter,
  isValid,
  format
} from 'date-fns';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const DatePicker = ({ onChange, defaultRange, minDate, maxDate }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // --- Effective bounds ------------------------------------------------------
  const maxDateStr = localStorage.getItem('max_date');
  const parsedMaxDate = maxDateStr ? new Date(maxDateStr) : null;

  const isValidDate = (d) => d instanceof Date && isValid(d);

  const effectiveMin = isValidDate(minDate) ? minDate : undefined;
  const lsMax = isValidDate(parsedMaxDate) ? parsedMaxDate : undefined;
  const propMax = isValidDate(maxDate) ? maxDate : undefined;
  const effectiveMax = lsMax ?? propMax ?? undefined;

  const shouldDisableAll = !effectiveMin && !effectiveMax;

  // Context for “Today”, etc. If out of bounds, we’ll clamp below anyway.
  const todayContext = effectiveMax ?? new Date();

  // --- Clamp helpers ---------------------------------------------------------
  const clampDate = (d) => {
    let x = d;
    if (effectiveMin && isBefore(x, effectiveMin)) x = effectiveMin;
    if (effectiveMax && isAfter(x, effectiveMax)) x = effectiveMax;
    return x;
  };

  const clampRange = ({ startDate, endDate }) => {
    let s = clampDate(startDate);
    let e = clampDate(endDate);
    if (isAfter(s, e)) s = e; // safety for very tight windows
    return { startDate: s, endDate: e };
  };

  const clampRangeArray = (arr) =>
    (arr || []).map((r) => ({ key: r.key || 'selection', ...clampRange(r) }));

  // --- Default / initial range ----------------------------------------------
  const getValidRange = () => {
    // pick an “end” (prefer effectiveMax; else today), then create a 6-day window
    const rawEnd = effectiveMax ?? new Date();
    const end = clampDate(rawEnd);

    let start = subDays(end, 5); // 5 days back = 6-day window
    start = clampDate(start);

    if (isAfter(start, end)) start = end;

    return [{ key: 'selection', startDate: start, endDate: end }];
  };
  const formatDateRange = () => {
  const range = state[0];
  if (!range.startDate || !range.endDate) {
    return 'No date available';
  }
  const formattedStart = format(range.startDate, 'dd/MM/yyyy');
  const formattedEnd = format(range.endDate, 'dd/MM/yyyy');
  return `${formattedStart} – ${formattedEnd}`;
  };

  const [state, setState] = useState(getValidRange());
  const [tempRange, setTempRange] = useState(getValidRange());

  // --- Static ranges (ALL clamped) ------------------------------------------
  const myStaticRanges = [
    { label: 'Today', range: () => clampRange({ startDate: todayContext, endDate: todayContext }) },
    { label: 'Yesterday', range: () => {
        const y = subDays(todayContext, 1);
        return clampRange({ startDate: y, endDate: y });
      },
    },
    { label: 'This Week', range: () => clampRange({
        startDate: startOfWeek(todayContext, { weekStartsOn: 0 }),
        endDate: endOfWeek(todayContext, { weekStartsOn: 0 }),
      }),
    },
    { label: 'Last Week', range: () => {
        const lw = subWeeks(todayContext, 1);
        return clampRange({
          startDate: startOfWeek(lw, { weekStartsOn: 0 }),
          endDate: endOfWeek(lw, { weekStartsOn: 0 }),
        });
      },
    },
    { label: 'This Month', range: () => clampRange({
        startDate: startOfMonth(todayContext),
        endDate: endOfMonth(todayContext),
      }),
    },
    { label: 'Last Month', range: () => {
        const lm = subMonths(todayContext, 1);
        return clampRange({
          startDate: startOfMonth(lm),
          endDate: endOfMonth(lm),
        });
      },
    },
  ];

  const customStaticRanges = [
    { label: 'This Year', range: () => clampRange({
        startDate: startOfYear(todayContext),
        endDate: endOfYear(todayContext),
      }),
    },
    { label: 'Last Year', range: () => {
        const ly = subYears(todayContext, 1);
        return clampRange({
          startDate: startOfYear(ly),
          endDate: endOfYear(ly),
        });
      },
    },
  ];

  const staticRanges = createStaticRanges(
    shouldDisableAll ? [] : [...myStaticRanges, ...customStaticRanges]
  );

  // --- Close on outside click ------------------------------------------------
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // --- Normalize + CLAMP incoming defaultRange ------------------------------
  const normalizeRange = (range) =>
    (range || []).map((r) => ({
      ...r,
      startDate: new Date(r.startDate),
      endDate: new Date(r.endDate),
      key: r.key || 'selection',
    }));
  useEffect(() => {
    if (
      defaultRange &&
      Array.isArray(defaultRange) &&
      defaultRange[0]?.startDate &&
      defaultRange[0]?.endDate
    ) {
      const bounded = clampRangeArray(normalizeRange(defaultRange));
      setState(bounded);
      setTempRange(bounded);
    } else {
      const initial = getValidRange();
      setState(initial);
      setTempRange(initial);
    }
    // Only re-run if raw inputs change
    // 🚨 DO NOT include effectiveMin / effectiveMax (they're recalculated each render)
  }, [defaultRange, minDate, maxDate, maxDateStr]);


  // --- Enforce clamping on every user change --------------------------------
  const handleRangeChange = (item) => {
    if (shouldDisableAll) return;
    const clamped = clampRangeArray([item.selection]);
    setTempRange(clamped);
  };

  const handleApply = () => {
    const clamped = clampRangeArray(tempRange);
    setState(clamped);
    onChange && onChange(clamped);
    setOpen(false);
  };

  const formatDate = (date) => {
    if (!date) return 'No date available';
    return date.toLocaleDateString('en-GB'); // 'dd/mm/yyyy' format
  };

  // --- Render ----------------------------------------------------------------
  return (
    <div
      className="inline-block text-left w-full max-w-md custom-date-picker"
      ref={ref}
      style={{ position: 'relative', fontSize: 'smaller' }}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full border rounded date-picker-btn text-black text-left"
        disabled={shouldDisableAll}
      >
        {formatDate(state[0].startDate)} &nbsp;-&nbsp; {formatDate(state[0].endDate)} &nbsp;

        <i className="bi bi-calendar" />
      </button>

      {open && (
        <div className="absolute z-50 mt-2 shadow-lg overflow-x-auto datepicker-outer-div" style={{ zIndex: 99999999 }}>
          <DateRangePicker
            onChange={handleRangeChange}
            showSelectionPreview
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={tempRange}
            showDateDisplay
            direction={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
            staticRanges={staticRanges}
            inputRanges={[]}
            // IMPORTANT: do NOT fall back to new Date() here
            minDate={shouldDisableAll ? undefined : effectiveMin}
            maxDate={shouldDisableAll ? undefined : effectiveMax}
            disabled={shouldDisableAll}
          />
          <div className="p-2 text-right apply-btn-datepicker">
            <button className="btn auth-btn-datepicker mb-2" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePicker;
